/* global dataLayer */
import _ from 'underscore';
import $ from 'jquery';
import dataLayerEventsHelpers from '../twig/analytics/data-layer-events-helpers';

const HEADER_PRIMARY_NAV_LINK_SELECTORS = [
  '#navigation .header__inner .header__links__items > a',
  '#navigation .header__inner .header__call a'
];

const HEADER_PRIMARY_NAV_CHILD_LINK_SELECTORS = [
  '#navigation .header__inner .header__links--child a'
];

const setupHeaderPrimaryNavLinkClickEvents = () => {
  const headerPrimaryNavLinkElements = dataLayerEventsHelpers.getElements(
    HEADER_PRIMARY_NAV_LINK_SELECTORS
  );
  _.each(headerPrimaryNavLinkElements, (link) => {
    link.addEventListener('click', () => {
      dataLayer.push({
        event: 'navigation',
        navType: 'Main',
        navText: link.textContent
      });
    });
  });
};

const setupHeaderPrimaryNavChildLinkClickEvents = () => {
  const headerPrimaryNavChildLinkElements = dataLayerEventsHelpers.getElements(
    HEADER_PRIMARY_NAV_CHILD_LINK_SELECTORS
  );
  _.each(headerPrimaryNavChildLinkElements, (link) => {
    link.addEventListener('click', () => {
      const navText = dataLayerEventsHelpers.getChildLinkEventText(link);
      dataLayer.push({ event: 'navigation', navType: 'Main', navText });
    });
  });
};

function headerLinkClickText(clickEvent, childClass) {
  const linkClassList = clickEvent.target.parentNode.parentNode.classList;
  let linkIsChild =
    _.contains(linkClassList, childClass) ||
    _.contains(linkClassList, 'header__links--subchild-list');
  const linkIsLogo = clickEvent.target.tagName === 'IMG';
  const linkLabel = clickEvent.target.text;
  const linkParent = clickEvent.target.parentNode.parentNode.parentNode;
  const linkParentLabelDesktop = linkParent.querySelector('a').text;
  const linkParentLabelMobile = clickEvent.target.dataset.parentLabel;
  if (linkParentLabelMobile === 'Blog') {
    linkIsChild = false;
  }

  const linkParentLabel = linkParentLabelMobile || linkParentLabelDesktop;
  const childText = clickEvent.target.firstChild
    ? clickEvent.target.firstChild.textContent
    : '';
  let linkText;

  if (linkIsChild) {
    linkText = `${linkParentLabel} > ${linkLabel}`;
  } else if (linkIsLogo) {
    linkText = 'ShopKeep Logo';
  } else if (childText) {
    linkText = childText;
  } else {
    linkText = linkLabel;
  }

  return linkText;
}

const dataLayerEvents = {
  footerLinkClick() {
    const mainLeftLinks = document.querySelectorAll(
      '#footer .footer__main__left a'
    );
    _.each(mainLeftLinks, (link) => {
      link.addEventListener('click', (e) => {
        const linkText = e.target.innerHTML;
        dataLayer.push({
          event: 'navigation',
          navType: 'Footer',
          navText: linkText
        });
      });
    });

    const contactAndBottomLinks = document.querySelectorAll(
      '#footer .footer__main .footer__main__right .footer__contact__info a, #footer .footer__bottom a'
    );
    _.each(contactAndBottomLinks, (link) => {
      link.addEventListener('click', () => {
        const linkText = link.querySelector('span').innerHTML;
        dataLayer.push({
          event: 'navigation',
          navType: 'Footer',
          navText: linkText
        });
      });
    });
  },

  footerSocialLinkClick() {
    const links = document.querySelectorAll(
      '#footer .footer__main .footer__main__right .social-links a'
    );
    _.each(links, (link) => {
      link.addEventListener('click', (e) => {
        const linkText = e.target.getAttribute('title');
        dataLayer.push({
          event: 'navigation',
          navType: 'Footer',
          navText: linkText
        });
      });
    });
  },

  navDropDownLinkClick() {
    function clickAction() {
      const linkText =
        $(this)
          .find('h3')
          .first()
          .text() || $(this).text();
      const linkUrl = $(this).attr('href');

      dataLayer.push({
        event: 'navigation',
        navType: 'Main',
        navText: linkText,
        navUrl: linkUrl
      });
    }

    $('.sk17-dropdown__group a').click(clickAction);
  },

  navDropdownToggleClick(isVisible) {
    dataLayer.push({
      event: 'menuState',
      menuState: isVisible ? 'Expand' : 'Close'
    });
  },

  headerSearchClick() {
    const search = document.querySelector('.nav__sub__search');
    if (search) {
      search.addEventListener('click', () => {
        dataLayer.push({
          event: 'navigation',
          navType: 'Blog',
          navText: 'Search'
        });
      });
    }
  },

  headerBlogLinkClick() {
    const links = document.querySelectorAll('.nav__sub a');
    _.each(links, (link) => {
      link.addEventListener('click', (e) => {
        const linkText = headerLinkClickText(e, 'nav__sub__links--child');
        dataLayer.push({
          event: 'navigation',
          navType: 'Blog',
          navText: linkText
        });
      });
    });
  },

  headerTopLinkClick() {
    const links = document.querySelectorAll('.nav__top a');
    _.each(links, (link) => {
      link.addEventListener('click', (e) => {
        const linkText = e.target.innerHTML;
        dataLayer.push({
          event: 'navigation',
          navType: 'Top',
          navText: linkText
        });
      });
    });
  },

  headerLoginSubmitClick() {
    if (!document.querySelector('#navigation')) return;
    if (!document.querySelector('#backoffice-login-submit')) return;

    const button = document.querySelector('#backoffice-login-submit');
    const field = document.querySelector('input[name="storename"]');

    button.addEventListener('click', () => {
      if (field.value === '') return;
      dataLayer.push({ event: 'login', account: field.value });
    });
  },

  headerLoginLinkClick() {
    $('.js-backoffice-login-link').click(() => {
      dataLayer.push({ event: 'login', account: 'Account Validation Removed' });
    });
  },

  logoClick() {
    const logoSelectors = [
      '.sk17-nav__logo a',
      '.sk17-dropdown__logo a',
      '#navigation a.header__logo'
    ].join(', ');

    function logoSelectorsClick() {
      const navUrl = $(this).attr('href');
      dataLayer.push({
        event: 'navigation',
        navType: 'Main',
        navText: 'ShopKeep Logo',
        navUrl
      });
    }

    $(logoSelectors).click(logoSelectorsClick);
  },

  pageScroll() {
    if (document.querySelector('.slide--active')) return;
    const pageScrollArray = [];

    const pageScrollEventFire = (num) => {
      if (pageScrollArray.indexOf(num) > -1) return;
      dataLayer.push({
        event: 'pageScroll',
        scrollDepth: `${num}%`
      });
      pageScrollArray.push(num);
    };

    const pageScrollListener = () => {
      const scrollMaxY =
        document.documentElement.getBoundingClientRect().height -
        window.innerHeight;
      const scrollY = window.pageYOffset;

      switch (true) {
        case scrollY >= scrollMaxY - 0.5:
          pageScrollEventFire(0);
          pageScrollEventFire(25);
          pageScrollEventFire(50);
          pageScrollEventFire(75);
          pageScrollEventFire(100);
          break;
        case scrollY >= scrollMaxY * 0.75:
          pageScrollEventFire(0);
          pageScrollEventFire(25);
          pageScrollEventFire(50);
          pageScrollEventFire(75);
          break;
        case scrollY >= scrollMaxY * 0.5:
          pageScrollEventFire(0);
          pageScrollEventFire(25);
          pageScrollEventFire(50);
          break;
        case scrollY >= scrollMaxY * 0.25:
          pageScrollEventFire(0);
          pageScrollEventFire(25);
          break;
        default:
          pageScrollEventFire(0);
          break;
      }
    };

    setTimeout(() => {
      pageScrollListener();
      document.addEventListener('scroll', pageScrollListener, false);
    }, 500);
  },

  // Global events only
  initEvents() {
    dataLayerEvents.pageScroll();
    dataLayerEvents.footerLinkClick();
    dataLayerEvents.footerSocialLinkClick();
    dataLayerEvents.headerLoginLinkClick();
    dataLayerEvents.headerTopLinkClick();
    dataLayerEvents.headerBlogLinkClick();
    dataLayerEvents.headerSearchClick();
    dataLayerEvents.headerLoginSubmitClick();
    dataLayerEvents.navDropDownLinkClick();
    dataLayerEvents.logoClick();
    setupHeaderPrimaryNavLinkClickEvents();
    setupHeaderPrimaryNavChildLinkClickEvents();
  },

  // Global events only
  init() {
    if (document.readyState !== 'loading') {
      setTimeout(() => {
        dataLayerEvents.initEvents();
      }, 100);
    } else {
      document.addEventListener('DOMContentLoaded', () => {
        dataLayerEvents.initEvents();
      });
    }
  }
};

export default dataLayerEvents;
